export const GETALL_REPAIRMAN_REQUEST = "GETALL_REPAIRMAN_REQUEST";
export const GETALL_REPAIRMAN_SUCCESS = "GETALL_REPAIRMAN_SUCCESS";
export const GETALL_REPAIRMAN_FAIL = "GETALL_REPAIRMAN_FAIL";

export const GETBYID_REPAIRMAN_REQUEST = "GETBYID_REPAIRMAN_REQUEST";
export const GETBYID_REPAIRMAN_SUCCESS = "GETBYID_REPAIRMAN_SUCCESS";
export const GETBYID_REPAIRMAN_FAIL = "GETBYID_REPAIRMAN_FAIL";

export const ADD_REPAIRMAN_REQUEST = 'ADD_REPAIRMAN_REQUEST';
export const ADD_REPAIRMAN_SUCCESS = 'ADD_REPAIRMAN_SUCCESS';
export const ADD_REPAIRMAN_FAIL = 'ADD_REPAIRMAN_FAIL';

export const UPDATE_REPAIRMAN_REQUEST = 'UPDATE_REPAIRMAN_REQUEST';
export const UPDATE_REPAIRMAN_SUCCESS = 'UPDATE_REPAIRMAN_SUCCESS';
export const UPDATE_REPAIRMAN_FAIL = 'UPDATE_REPAIRMAN_FAIL';

export const DELETE_REPAIRMAN_REQUEST = 'DELETE_REPAIRMAN_REQUEST';
export const DELETE_REPAIRMAN_SUCCESS = 'DELETE_REPAIRMAN_SUCCESS';
export const DELETE_REPAIRMAN_FAIL = 'DELETE_REPAIRMAN_FAIL';